import React from 'react'
import ToolItem from './tool-item'
import Modal from '../shared/Modal'
import {ItemsContainer, ToolsContentWrapper} from './styled'
import {useNavigate} from 'react-router-dom'
import {getAuthByRole} from '../../utils/get-screen-auth-by-role'
import {useUserRoles} from '../../utils/use-user-roles'
import {TOOL_SECTIONS} from './tools-consts'
import {ToolItemModal} from './tool-item-modal'

const ToolsContainer = ({section: sectionId}) => {
  const [activeToolId, setActiveToolId] = React.useState(null)

  const {roles} = useUserRoles()
  const navigate = useNavigate()

  const section = TOOL_SECTIONS.find(s => s.id === sectionId)
  const tools = React.useMemo(
    () => section?.build({roles}) ?? [],
    [section, roles],
  )

  const activeTool = tools.find(t => t.id === activeToolId) ?? null

  const handleToolClick = tool => {
    if (tool.type === 'navigate') return navigate(tool.to)
    setActiveToolId(tool.id)
  }

  const handleClose = () => setActiveToolId(null)

  const visibleTools = tools
    .filter(tool => !tool.hidden)
    .filter(
      tool => !tool.requiredRoles || getAuthByRole(tool.requiredRoles, roles),
    )

  return (
    <ToolsContentWrapper>
      {activeTool?.type === 'modal' && (
        <ToolItemModal
          open
          title={activeTool.title}
          url={activeTool.url}
          redirectUrl={activeTool.redirectUrl ?? ''}
          onClose={handleClose}
        />
      )}
      {activeTool?.type === 'custom-modal' && (
        <Modal onClose={handleClose}>
          {React.createElement(activeTool.modal, {close: handleClose})}
        </Modal>
      )}
      <ItemsContainer>
        {visibleTools.map(tool => (
          <ToolItem
            key={tool.id}
            label={tool.title}
            src={tool.image}
            alt={`${tool.title} Logo`}
            isActive={tool.id === activeToolId}
            {...(tool.type === 'link'
              ? {redirectUrl: tool.url}
              : {onClick: () => handleToolClick(tool)})}
          />
        ))}
      </ItemsContainer>
    </ToolsContentWrapper>
  )
}

export default ToolsContainer
